import { render, staticRenderFns } from "./FormSocialSecurity.vue?vue&type=template&id=6d023f17"
import script from "./FormSocialSecurity.vue?vue&type=script&lang=js"
export * from "./FormSocialSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports